function n(e, u) {
  return e == null ? void 0 : e[u];
}
var a = n;
export {
  a as default
};
//# sourceMappingURL=_getValue.js.map
